import Button from "devextreme-react/button";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitDesign } from "../api/submit-design";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function SubmitDesignButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const submitDesign = useSubmitDesign(
		order.details.retailOrderID,
		() => {
			showSuccessMessage("Cabinet Design has been submitted");
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-design' }}
				text={"Submit Design"}
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign)}
				disabled={submitDesign.isLoading}
				onClick={() => {
					if (!order.details.files.find(x => x.fileTypeID === FileTypes.CabinetDesignPacket)) {
						showErrorMessage('Cabinet Design Packet file is required');
					}
					else {
						submitDesign.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitDesign.isLoading}></LoadPagePanel>
		</>
	)
}
